module.exports = __webpack_public_path__ + "static/media/radiation_safety_plan_manage_employee.7ae8e975.svg";